/* Chip */
import classNames from "classnames"

import { ChipProps } from "@/types/components/chip"
import Icon from "@/components/icon/Icon"
import { colorTokens } from "@/components/colorTokens"

import "./chip.scss"

export default function Chip({
  type = "default-small",
  label,
  disabled,
  error,
  ...props
}: ChipProps) {
  const className = classNames("ChipCont", [type], props.className, {
    disabled,
    error,
  })

  return (
    <div className={className} onClick={props.onClick}>
      <p>{label}</p>
      {type === "deletable" && <Icon type="close" color={colorTokens.icon.enabled} size={20} />}
      {type === "serial" && (
        <Icon type="switch" width={12} height={12} color={colorTokens.icon.enabled} />
      )}
    </div>
  )
}
